import type {ISurveyPropertyRegion} from "../../types/IBuildSurveyParams";
import {parseToNumber} from "./parse_to_number";

const getGeneralRegionIdForSurvey = (region: ISurveyPropertyRegion): number => {
    const {id, stats} = region;

    // is district
    if (stats?.region_type_district?.id) {
        return stats.region_type_district.id;
    }

    // has county
    if (stats?.region_type_county?.id) {
        return stats.region_type_county.id;
    }

    // fallback, own id
    return id;
};

/**
 * Merges regions from all available sources.
 * When only property/offer details are available (no filters/survey), elevates to district/county.
 * When other sources exist, uses the original region ID from property/offer.
 */
export const surveyMergeRegions = (
    surveyRegions: number[] | undefined,
    propertyRegion: ISurveyPropertyRegion | undefined,
    offerRegion: ISurveyPropertyRegion | undefined,
    filterRegions: string[] | undefined,
    doFiltersOrSurveyExist: boolean
): number[] => {
    const regions = new Set<number>(surveyRegions || []);

    // Add region from property details
    if (propertyRegion) {
        // When only property details (no filters/survey), elevate to district/county
        // When other sources exist, use original region ID
        const regionId = doFiltersOrSurveyExist ? propertyRegion.id : getGeneralRegionIdForSurvey(propertyRegion);
        regions.add(regionId);
    }

    // Add region from offer details
    if (offerRegion) {
        const regionId = doFiltersOrSurveyExist ? offerRegion.id : getGeneralRegionIdForSurvey(offerRegion);
        regions.add(regionId);
    }

    if (filterRegions && filterRegions.length > 0) {
        for (const region of filterRegions) {
            const parsed = parseToNumber(region);

            if (parsed !== null) {
                regions.add(parsed);
            }
        }
    }

    return Array.from(regions);
};
import type {ISurveyPropertyRegion} from "../../types/IBuildSurveyParams";
import {parseToNumber} from "./parse_to_number";

const getGeneralRegionIdForSurvey = (region: ISurveyPropertyRegion): number => {
    const {id, stats} = region;

    // is district
    if (stats?.region_type_district?.id) {
        return stats.region_type_district.id;
    }

    // has county
    if (stats?.region_type_county?.id) {
        return stats.region_type_county.id;
    }

    // fallback, own id
    return id;
};

/**
 * Merges regions from all available sources.
 * When only property/offer details are available (no filters/survey), elevates to district/county.
 * When other sources exist, uses the original region ID from property/offer.
 */
export const surveyMergeRegions = (
    surveyRegions: number[] | undefined,
    propertyRegion: ISurveyPropertyRegion | undefined,
    offerRegion: ISurveyPropertyRegion | undefined,
    filterRegions: string[] | undefined,
    doFiltersOrSurveyExist: boolean
): number[] => {
    const regions = new Set<number>(surveyRegions || []);

    // Add region from property details
    if (propertyRegion) {
        // When only property details (no filters/survey), elevate to district/county
        // When other sources exist, use original region ID
        const regionId = doFiltersOrSurveyExist ? propertyRegion.id : getGeneralRegionIdForSurvey(propertyRegion);
        regions.add(regionId);
    }

    // Add region from offer details
    if (offerRegion) {
        const regionId = doFiltersOrSurveyExist ? offerRegion.id : getGeneralRegionIdForSurvey(offerRegion);
        regions.add(regionId);
    }

    if (filterRegions && filterRegions.length > 0) {
        for (const region of filterRegions) {
            const parsed = parseToNumber(region);

            if (parsed !== null) {
                regions.add(parsed);
            }
        }
    }

    return Array.from(regions);
};
